import { render, staticRenderFns } from "./UniRequestReport.vue?vue&type=template&id=52075792&"
import script from "./UniRequestReport.vue?vue&type=script&lang=js&"
export * from "./UniRequestReport.vue?vue&type=script&lang=js&"
import style0 from "./UniRequestReport.vue?vue&type=style&index=0&id=52075792&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports